import supportImg from 'Images/onboarding_support.svg?url'
import ecomImg from 'Images/onboarding_ecom.svg?url'
import salesImg from 'Images/onboarding_sales.svg?url'
import leadsImg from 'Images/onboarding_leads.svg?url'
import answerQuestionsImg from 'Images/onboarding_answer_questions.svg?url'
import bookMeetingsImg from 'Images/onboarding_book_meetings.svg?url'
import noneImg from 'Images/onboarding_none.svg?url'
import reduceTicketVolumeImg from 'Images/onboarding_reduce_ticket_volume.svg?url'
import reduceRepeatedQuestnImg from 'Images/onboarding_reduce_repeated_questions.svg?url'
import provideResourcesHelpImg from 'Images/onboarding_provide_resources_help.svg?url'
import handleReturnsRefundsImg from 'Images/onboarding_handle_returns_refunds.svg?url'
import fetchOrderStatusImg from 'Images/onboarding_fetch_order_status.svg?url'
import checkAvailabilityImg from 'Images/onboarding_check_availability.svg?url'
import collectInformationImg from 'Images/onboarding_collect_information.svg?url'
import increaseEngagementImg from 'Images/onboarding_increase_engagement.svg?url'

export const ACTION = {
  UPDATE_PURPOSE_OF_ONBOARDING_LIST: 'UPDATE_PURPOSE_OF_ONBOARDING_LIST',
  UPDATE_GOALS_LIST: 'UPDATE_GOALS_LIST'
}

export const onboardingJson = {
  question: {
    step1: {
      subtitle: ''
    },
    step2: {
      subtitle: 'We’ll personalize recommendations based on your goals.'
    },
    step3: {
      subtitle: 'Use the slider below to pick an approximate <%= s %> volume'
    }
  },
  purposeOfOnboarding: [
    {
      title: 'Ease support operations',
      subtitle: 'Deflect tickets and reduce support ticket volume',
      intent: 'Support',
      selected: false,
      imageName: 'support',
      imageURL: supportImg,
      id: 1
    },
    {
      title: 'Drive higher sales',
      subtitle: 'Shorten your sales cycle and drive more revenue',
      intent: 'Sales',
      selected: false,
      imageName: 'sales',
      imageURL: salesImg,
      id: 2
    },
    {
      title: 'Boost E-Commerce',
      subtitle: 'Offer contextual support to more customers',
      intent: 'E-Commerce',
      selected: false,
      imageName: 'ecom',
      imageURL: ecomImg,
      id: 3
    },
    {
      title: 'Explore my options',
      subtitle: 'See what you can achieve with custom chatbots',
      intent: 'Others',
      selected: false,
      imageName: 'none',
      imageURL: noneImg,
      id: 4
    }
  ],
  goals: [
    {
      title: 'Reduce Ticket Volume',
      subtitle: '',
      selected: false,
      imageName: 'reduceTicketVolumeImg',
      imageURL: reduceTicketVolumeImg,
      id: 11,
      goalTypeId: 1 // support
    },
    {
      title: 'Reduce Repeated Questions',
      subtitle: '',
      selected: false,
      imageName: 'reduceRepeatedQuestnImg',
      imageURL: reduceRepeatedQuestnImg,
      id: 12,
      goalTypeId: 1 // support
    },
    {
      title: 'Provide Resources Help',
      subtitle: '',
      selected: false,
      imageName: 'provideResourcesHelpImg',
      imageURL: provideResourcesHelpImg,
      id: 13,
      goalTypeId: 1 // support
    },
    {
      title: 'Capture Leads',
      subtitle: '',
      selected: false,
      imageName: 'leads',
      imageURL: leadsImg,
      id: 14,
      goalTypeId: 2 // sales
    },
    {
      title: 'Book Meetings',
      subtitle: '',
      selected: false,
      imageName: 'book_meetings',
      imageURL: bookMeetingsImg,
      id: 15,
      goalTypeId: 2 // sales
    },
    {
      title: 'Answer sales questions',
      subtitle: '',
      selected: false,
      imageName: 'answer_questions',
      imageURL: answerQuestionsImg,
      id: 16,
      goalTypeId: 2 // sales
    },
    {
      title: 'Handle Returns and Refunds',
      subtitle: '',
      selected: false,
      imageName: 'handleReturnsRefundsImg',
      imageURL: handleReturnsRefundsImg,
      id: 17,
      goalTypeId: 3 // E-Commerce
    },
    {
      title: 'Fetch Order Status',
      subtitle: '',
      selected: false,
      imageName: 'fetchOrderStatusImg',
      imageURL: fetchOrderStatusImg,
      id: 18,
      goalTypeId: 3 // E-Commerce
    },
    {
      title: 'Check Availability',
      subtitle: '',
      selected: false,
      imageName: 'checkAvailabilityImg',
      imageURL: checkAvailabilityImg,
      id: 19,
      goalTypeId: 3 // E-Commerce
    },
    {
      title: 'Collect information',
      subtitle: '',
      selected: false,
      imageName: 'collectInformationImg',
      imageURL: collectInformationImg,
      id: 20,
      goalTypeId: 4 // Explore
    },
    {
      title: 'Increase Engagement',
      subtitle: '',
      selected: false,
      imageName: 'increaseEngagementImg',
      imageURL: increaseEngagementImg,
      id: 21,
      goalTypeId: 4 // Explore
    },
    {
      title: 'Book Meetings',
      subtitle: '',
      selected: false,
      imageName: 'book_meetings',
      imageURL: bookMeetingsImg,
      id: 22,
      goalTypeId: 4 // Explore
    }
  ],
  steps: [
    { id: 1, stepName: 'step_one', completed: true },
    { id: 2, stepName: 'step_two', completed: false },
    { id: 3, stepName: 'step_three', completed: false }
  ],
  slider: {
    min: 100,
    max: 25000,
    steps: 1
  }
}
